import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'CodeForce';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const WS_ENDPOINT_URL = env.WS_ENDPOINT_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/codeforce/dashboard`;
export const UNAUTHENTICATED_ENTRY = '/login'
// Base path + landing route for the Workspace Editor. Notes-only users are
// confined to this area of the app.
export const WORKSPACE_BASE_PATH = `${APP_PREFIX_PATH}/codeforce/workspace`;
export const WORKSPACE_ENTRY = `${APP_PREFIX_PATH}/codeforce/workspace/editor`;
export const MARKETER_BASE_PATH = `${APP_PREFIX_PATH}/marketer`;
export const MARKETER_ENTRY = `${APP_PREFIX_PATH}/marketer`;

export const isMarketerUser = (user) => Boolean(user?.marketerOnly || user?.role === 'marketer');

export const isWorkspaceOnlyUser = (user) => Boolean(user?.workspaceOnly) && !isMarketerUser(user);

/** Landing path after sign-in or PWA reopen, based on role flags. */
export const getPostAuthRoute = (user) => {
	if (isMarketerUser(user)) return MARKETER_ENTRY;
	if (isWorkspaceOnlyUser(user)) return WORKSPACE_ENTRY;
	return AUTHENTICATED_ENTRY;
};

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false,
	// 'sidebar' | 'launcher' (tablet-style app grid instead of the side menu)
	navLayout: 'sidebar',
};
